import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';

export function FAQ() {
  const { t } = useTranslation();
  const [open, setOpen] = useState<number | null>(0);
  const items = [
    { q: t('faq.q1'), a: t('faq.a1') },
    { q: t('faq.q2'), a: t('faq.a2') },
    { q: t('faq.q3'), a: t('faq.a3') },
    { q: t('faq.q4'), a: t('faq.a4') },
    { q: t('faq.q5'), a: t('faq.a5') },
  ];

  return (
    <section className="section">
      <div className="container-narrow max-w-3xl">
        <h2 className="font-pixel text-4xl sm:text-5xl font-bold tracking-tight text-center mb-16">
          {t('faq.title')}
        </h2>

        <div className="space-y-3">
          {items.map((it, i) => (
            <div
              key={i}
              className="kblock overflow-hidden"
            >
              <button
                className="w-full px-6 py-4 flex items-center justify-between gap-4 text-left hover:bg-kquest-700 transition-colors"
                onClick={() => setOpen(open === i ? null : i)}
              >
                <span className="font-pixel text-kquest-100">{it.q}</span>
                <ChevronDown
                  className={`w-5 h-5 text-gold-400 flex-shrink-0 transition-transform ${
                    open === i ? 'rotate-180' : ''
                  }`}
                />
              </button>
              <AnimatePresence initial={false}>
                {open === i && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: 'auto', opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.2 }}
                  >
                    <div className="px-6 pb-5 text-kquest-300 leading-relaxed">
                      {it.a}
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
